import { AsyncStore } from './AsyncStore';
import { Software } from '../ApiModel';
import { IApiClient } from '../ApiClient';
import { loadAllItems } from '../helper/PagingHelper';
import { computed, makeObservable } from 'mobx';

export class SoftwaresStore extends AsyncStore<Software[]> {
    constructor(apiClient: IApiClient) {
        super(() => loadAllItems((link) => apiClient.getSoftware(link)), []);
        makeObservable(this);
    }

    @computed
    get items() {
        return this.item;
    }
}
